import { Dispatch } from 'redux';

import backend from '../../../apis/backend';
import { ReduxState } from '../../state';
import { loginSuccess, loginFailure } from '../actions';
import { updateUser } from '../../user/actions';
import { updatePageOrderInputs } from '../../page/actions';
import { osName, osVersion, browserName, browserVersion, mobileVendor, mobileModel, deviceType } from 'react-device-detect';
import { eventFlowUpdate } from '../../events/actions';
import { asyncCartCreate } from '../../cart/initiators';

export const asyncCheckVerificationCode = (navigation: any) => {
  return async (dispatch: Dispatch<any>, getState: () => ReduxState) => {
    const { pageOrderFlow } = getState().page;
    const { eventFlow } = getState().events;
    try {
      const { phoneNumber, verificationCode } = getState().auth.loginFlow;
      const location = getState().location.geolocatedCoordinates;
      const response = await backend.post(`/api/v1/check-verification-code`, 
      { 
        phoneNumber, 
        verificationCode, 
        app: 'pages-ui',
        data: {
          osName, osVersion, browserName, browserVersion, 
          mobileVendor, mobileModel, deviceType, location        
        } 
      });
      if (response.status === 200) {
        const { user, token } = response.data;
        const userId = user._id;
        dispatch(loginSuccess(token));
        dispatch(updatePageOrderInputs({ ...pageOrderFlow, userId, creatorId: userId }));
        dispatch(eventFlowUpdate({ ...eventFlow, userId }))
        dispatch(updateUser(user))
        dispatch(asyncCartCreate())
        localStorage.setItem('showfaPagesLoginToken', token);
        localStorage.setItem('showfaPagesUserId', user._id);
        navigation.next()
      } else {
        dispatch(loginFailure('Invalid verification code. Try again.'));
        dispatch(updateUser(null));
        dispatch(updatePageOrderInputs({ ...pageOrderFlow, userId: null, creatorId: null }));
      }
    } catch (error) {
      console.error('Invalid verification code. Try again.', error);
      dispatch(loginFailure('Invalid verification code. Try again.'));
      dispatch(updateUser(null));
      dispatch(updatePageOrderInputs({ ...pageOrderFlow, userId: null, creatorId: null }));
    }
  };
};